import { Box } from '@quintoandar-tokko/jopijs';
import styles from './portalsNotifications.module.scss';
import PropertyNotificationsCard from './PortalsNotificationsCards/PropertyNotificationsCard';
import PortalsNotificationsCard from './PortalsNotificationsCards/PortalsNotificationsCard';
import { showCardSeparator, showRemainingEntitiesCard } from '../utils';
import RemainingEntityCard from './PortalsNotificationsCards/RemainingEntityCard';

function PortalsNotificatonsContainer({
  portals = [],
  properties = [],
  trackCallback = null,
}) {
  const hasRemainingProp = showRemainingEntitiesCard(properties);
  const hasRemainingPortal = showRemainingEntitiesCard(portals);

  const splitPropIndex = hasRemainingProp ? 3 : 4;
  const splitPortalIndex = hasRemainingPortal ? 3 : 4;

  return (
    <Box className={styles.portalsNotificatonsContainer}>
      {properties.slice(0, splitPropIndex).map((property, index) => (
        <Box key={property.id}>
          <PropertyNotificationsCard
            property={property}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, properties) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
      {hasRemainingProp && properties.length > 0 && (
        <RemainingEntityCard
          entity={properties.slice(splitPropIndex)}
          type="property"
        />
      )}
      {portals.slice(0, splitPortalIndex).map((portal, index) => (
        <Box key={portal.id}>
          <PortalsNotificationsCard
            portal={portal}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, portals) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
      {hasRemainingProp && portals.length > 0 && (
        <RemainingEntityCard
          entity={portals.slice(splitPortalIndex)}
          type="portals"
        />
      )}
    </Box>
  );
}

export default PortalsNotificatonsContainer;
